<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
    <v-card>
      <v-card-title class="headline grey lighten-2">
        <div class="d-flex">
          <span>Documento</span>

          <template v-if="datos">
            <span class="ml-2"> de {{ nombreCompletoEstudiante }} </span>

            <span class="ml-2 subtitle-1 grey--text"> ({{ datos.documentoPersona.tipoDocumentoPersona.nombre }}) </span>
          </template>
        </div>

        <v-spacer></v-spacer>

        <v-btn icon @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-container v-if="cargando" class="fill-height">
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>

              <p class="mt-4">Cargando documento...</p>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-else-if="error" class="fill-height">
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-icon color="error" size="64">mdi-alert-circle</v-icon>

              <p class="mt-4 error--text">{{ mensajeError }}</p>
            </v-col>
          </v-row>
        </v-container>

        <div v-else-if="datos">
          <v-card flat class="pa-4">
            <v-row>
              <v-col cols="12">
                <v-alert v-if="datos.eliminadoEn" type="error">
                  <div class="d-flex flex-wrap justify-space-between align-center">
                    Este documento fue reemplazado por otro el {{ formatearFecha(datos.eliminadoEn) }}

                    <v-btn
                      color="primary"
                      class="ma-1"
                      small
                      @click="
                        $router.push({
                          name: 'documentos-inscripciones-ver',
                          params: { id: datos.reemplazoId },
                        })
                      ">
                      Ver documento reemplazo
                    </v-btn>
                  </div>
                </v-alert>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <strong>Datos del Documento:</strong>

                <div v-if="datos.documentoPersona.datos.length === 0" class="mx-2 text-caption">
                  No hay datos disponibles
                </div>

                <div v-for="dato in datos.documentoPersona.datos" :key="dato.id">
                  <strong>{{ dato.nombre }}:</strong>
                  <span class="mx-2 text-caption">{{ dato.valor }}</span>
                </div>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <div class="d-flex align-center">
                  <strong>Estado:</strong>
                  <div class="d-flex justify-space-between align-center">
                    <v-chip class="mx-2" small dark :color="colorEstado">
                      {{ datos.documentoPersona.estadoRevision }}
                    </v-chip>

                    <v-btn
                      v-if="datos.documentoPersona.archivoRespaldoId"
                      class="my-1 ml-2"
                      color="primary"
                      title="Ver respaldo adjunto"
                      outlined
                      small
                      icon
                      @click="verRespaldoGuardado">
                      <v-icon size="20">mdi-eye</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div>
                  <strong>Fecha de Revisión:</strong>
                  <span class="mx-2">{{ formatearFecha(datos.documentoPersona.fechaHoraRevision) }}</span>
                </div>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <strong>Observaciones:</strong>
                <span class="mx-2 text-caption">{{ datos.documentoPersona.observaciones || '-' }}</span>
              </v-col>
            </v-row>
          </v-card>

          <div v-if="datos.documentoPersona?.archivo" class="documento-viewer">
            <iframe v-if="esPdf" :src="urlDocumento" width="100%" height="600px" style="border: none"></iframe>

            <div v-else-if="esImagen" class="text-center">
              <v-img :src="urlDocumento" max-height="600" contain></v-img>
            </div>

            <div v-else class="text-center pa-8">
              <v-icon size="64" color="grey">mdi-file-document-outline</v-icon>

              <p class="mt-4">Formato de archivo no soportado para previsualización</p>

              <v-btn color="primary" @click="descargarDocumento">
                <v-icon left>mdi-download</v-icon>

                Descargar documento
              </v-btn>
            </div>
          </div>

          <v-alert v-else class="mt-5 mx-3" border="left" colored-border type="warning" text>
            No hay archivo disponible para este registro. Es posible que el archivo haya sido eliminado o que no se haya
            subido correctamente.
          </v-alert>
        </div>
      </v-card-text>

      <v-divider class="my-1"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" @click="descargarDocumento" :disabled="!urlDocumento">
          <v-icon left>mdi-download</v-icon>
          Descargar
        </v-btn>

        <v-btn text @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogoRespaldo" max-width="600px">
      <v-card>
        <v-card-title class="primary--text">
          <span> Vista Previa del Respaldo </span>

          <v-spacer></v-spacer>

          <v-btn icon @click="dialogoRespaldo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <ImagenPreview v-if="respaldoEsImagen" :src="previsualizacion" nombre-archivo="Respaldo" />
          <PdfPreview v-else-if="respaldoEsPDF" :src="previsualizacion" nombre-archivo="Respaldo" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import inscripcionesDocumentosPersonasService from '../../../comisiones/services/inscripciones-documentos-personas.service';
import ImagenPreview from '../../../documentacion/components/ImagenPreview.vue';
import PdfPreview from '../../../documentacion/components/PdfPreview.vue';

export default {
  name: 'ModalPrevisualizacion',
  components: {
    ImagenPreview,
    PdfPreview,
  },
  data() {
    return {
      dialog: false,
      cargando: false,
      error: false,
      mensajeError: '',
      datos: null,
      inscripcionDocumentoPersonaId: null,
      dialogoRespaldo: false,
      previsualizacion: null,
      respaldoEsImagen: false,
      respaldoEsPDF: false,
    };
  },
  computed: {
    nombreCompletoEstudiante() {
      if (!this.datos) {
        return '';
      }

      const est = this.datos.inscripcion.estudiante;
      return `${est.nombres} ${est.primerApellido} ${est.segundoApellido || ''}`;
    },
    esPdf() {
      return this.datos?.documentoPersona?.archivo?.mimetype === 'application/pdf';
    },
    esImagen() {
      const mimetype = this.datos?.documentoPersona?.archivo?.mimetype || '';
      return mimetype.startsWith('image/');
    },
    urlDocumento() {
      if (!this.datos?.documentoPersona?.archivo?.file64) return '';

      try {
        const base64Data = this.datos.documentoPersona.archivo.file64;
        const mimetype = this.datos.documentoPersona.archivo.mimetype;

        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimetype });

        return URL.createObjectURL(blob);
      } catch (error) {
        window.console.error('Error al convertir base64 a blob:', error);
        return '';
      }
    },
    colorEstado() {
      const estado = this.datos?.documentoPersona?.estadoRevision;
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
  },
  methods: {
    async abrir(id) {
      this.inscripcionDocumentoPersonaId = id;
      this.dialog = true;
      await this.cargarDocumento(id);
    },
    async cargarDocumento(id) {
      this.cargando = true;
      this.datos = null;

      try {
        const response = await inscripcionesDocumentosPersonasService.findOne(id);
        const data = response.data;

        this.datos = data.datos;
      } catch (err) {
        const response = err.response;
        const data = response?.data;

        this.error = true;
        this.mensajeError = data?.mensaje || 'Error al cargar el documento';
      } finally {
        this.cargando = false;
      }
    },
    cerrar() {
      this.dialog = false;
      this.datos = null;
      this.inscripcionDocumentoPersonaId = null;
      this.error = false;
      this.mensajeError = '';
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return '-';
      }

      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    descargarDocumento() {
      if (!this.urlDocumento) {
        return;
      }

      const archivo = this.datos.documentoPersona.archivo;
      const link = document.createElement('a');
      const tipoDocumentoPersona = this.datos.documentoPersona.tipoDocumentoPersona.nombre;
      const nombreCompletoEstudiante = this.nombreCompletoEstudiante.replace(/\s+/g, '_');

      link.href = this.urlDocumento;
      link.download = `${nombreCompletoEstudiante}-${tipoDocumentoPersona}.${archivo.extencion}`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verRespaldoGuardado() {
      const respaldo = this.datos?.documentoPersona?.archivoRespaldo;

      if (!respaldo?.file64) return;

      try {
        const byteCharacters = atob(respaldo.file64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: respaldo.mimetype });

        this.previsualizacion = URL.createObjectURL(blob);
        this.respaldoEsImagen = respaldo.mimetype.startsWith('image/');
        this.respaldoEsPDF = respaldo.mimetype === 'application/pdf';
        this.dialogoRespaldo = true;
      } catch (error) {
        window.console.error('Error al cargar respaldo guardado:', error);
      }
    },
  },
};
</script>

<style scoped>
.documento-viewer {
  min-height: 600px;
  background-color: #f5f5f5;
}
</style>